<template>
  <div class="card">
    <h3>竞品报价录入</h3>
    <div class="grid">
      <select v-model="quoteForm.merchant_id">
        <option value="">请选择商家*</option>
        <option v-for="merchant in merchants" :key="merchant.id" :value="merchant.id">
          {{ merchant.name }}（ID:{{ merchant.id }}）
        </option>
      </select>
      <input v-model.trim="quoteForm.brand" list="quoteBrandOptions" placeholder="品牌（可输入/可选择）*" @input="onQuoteBrandChange" />
      <datalist id="quoteBrandOptions">
        <option v-for="brand in brands" :key="`qb-${brand}`" :value="brand">{{ brand }}</option>
      </datalist>
      <input v-model.trim="quoteForm.model_name" list="quoteModelOptions" placeholder="型号（可输入/可选择）*" @input="onQuoteModelChange" />
      <datalist id="quoteModelOptions">
        <option v-for="model in quoteModels" :key="`qm-${model}`" :value="model">{{ model }}</option>
      </datalist>
      <input v-model.trim="quoteForm.capacity" list="quoteCapacityOptions" placeholder="容量（可输入/可选择）" />
      <datalist id="quoteCapacityOptions">
        <option v-for="capacity in quoteCapacities" :key="`qc-${capacity}`" :value="capacity">{{ capacity }}</option>
      </datalist>
      <input v-model.trim="quoteForm.color" placeholder="颜色" />
      <input v-model.trim="quoteForm.version" placeholder="版本" />
      <input v-model.number="quoteForm.tenor_months" placeholder="期数*" @input="recalcQuoteMonthly" />
      <input v-model.number="quoteForm.down_payment" placeholder="首付*" @input="recalcQuoteMonthly" />
      <input v-model.number="quoteForm.total_price" placeholder="总租金*" @input="recalcQuoteMonthly" />
      <input v-model.number="quoteForm.buyout_price" placeholder="买断价*" />
      <input v-model.number="quoteForm.monthly_payment" placeholder="月供(自动计算)" readonly />
      <input v-model.trim="quoteForm.collected_at" placeholder="采集时间(YYYY-MM-DD HH:mm:ss)" />
      <input v-model.trim="quoteForm.source_url" placeholder="来源链接" />
    </div>
    <div class="actions">
      <button class="primary" @click="saveQuote">保存竞品报价</button>
    </div>

    <h3 style="margin-top: 18px;">我方报价录入</h3>
    <div class="grid">
      <input v-model.trim="ownForm.brand" list="ownBrandOptions" placeholder="品牌（可输入/可选择）*" @input="onOwnBrandChange" />
      <datalist id="ownBrandOptions">
        <option v-for="brand in brands" :key="`ob-${brand}`" :value="brand">{{ brand }}</option>
      </datalist>
      <input v-model.trim="ownForm.model_name" list="ownModelOptions" placeholder="型号（可输入/可选择）*" @input="onOwnModelChange" />
      <datalist id="ownModelOptions">
        <option v-for="model in ownModels" :key="`om-${model}`" :value="model">{{ model }}</option>
      </datalist>
      <input v-model.trim="ownForm.capacity" list="ownCapacityOptions" placeholder="容量（可输入/可选择）" />
      <datalist id="ownCapacityOptions">
        <option v-for="capacity in ownCapacities" :key="`oc-${capacity}`" :value="capacity">{{ capacity }}</option>
      </datalist>
      <input v-model.trim="ownForm.color" placeholder="颜色" />
      <input v-model.trim="ownForm.version" placeholder="版本" />
      <input v-model.number="ownForm.tenor_months" placeholder="期数*" @input="recalcOwnMonthly" />
      <input v-model.number="ownForm.down_payment" placeholder="首付*" @input="recalcOwnMonthly" />
      <input v-model.number="ownForm.total_price" placeholder="总租金*" @input="recalcOwnMonthly" />
      <input v-model.number="ownForm.buyout_price" placeholder="买断价*" />
      <input v-model.number="ownForm.monthly_payment" placeholder="月供(自动计算)" readonly />
      <input v-model.trim="ownForm.effective_at" placeholder="生效时间(YYYY-MM-DD HH:mm:ss)" />
    </div>
    <div class="actions">
      <button class="primary" @click="saveOwn">保存我方报价</button>
    </div>

    <h3 style="margin-top: 18px;">我方报价列表</h3>
    <table>
      <thead>
        <tr>
          <th>品牌</th>
          <th>型号</th>
          <th>规格</th>
          <th>期数</th>
          <th>首付</th>
          <th>总租金</th>
          <th>买断价</th>
          <th>月供</th>
          <th>生效时间</th>
          <th>操作</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="row in ownList" :key="`own-${row.id}`">
          <td>{{ row.brand }}</td>
          <td>{{ row.model_name }}</td>
          <td>{{ [row.capacity, row.color, row.version].filter(Boolean).join('/') }}</td>
          <td>{{ row.tenor_months }}</td>
          <td>{{ row.down_payment }}</td>
          <td>{{ row.total_price }}</td>
          <td>{{ row.buyout_price }}</td>
          <td>{{ row.monthly_payment }}</td>
          <td>{{ row.effective_at }}</td>
          <td><button @click="removeOwnQuote(row)">删除</button></td>
        </tr>
      </tbody>
    </table>

    <h3 style="margin-top: 18px;">竞品报价列表</h3>
    <div class="toolbar">
      <input v-model.trim="query.model_name" placeholder="型号筛选" />
      <input v-model.number="query.tenor_months" placeholder="期数筛选" />
      <button @click="fetchList">查询</button>
    </div>
    <table>
      <thead>
        <tr>
          <th>商家</th>
          <th>品牌</th>
          <th>型号</th>
          <th>规格</th>
          <th>期数</th>
          <th>首付</th>
          <th>总租金</th>
          <th>买断价</th>
          <th>月供</th>
          <th>采集时间</th>
          <th>操作</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="row in list" :key="row.id">
          <td>{{ row.merchant_name }}</td>
          <td>{{ row.brand }}</td>
          <td>{{ row.model_name }}</td>
          <td>{{ [row.capacity, row.color, row.version].filter(Boolean).join('/') }}</td>
          <td>{{ row.tenor_months }}</td>
          <td>{{ row.down_payment }}</td>
          <td>{{ row.total_price }}</td>
          <td>{{ row.buyout_price }}</td>
          <td>{{ row.monthly_payment }}</td>
          <td>{{ row.collected_at }}</td>
          <td><button @click="removeQuote(row)">删除</button></td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import {
  quoteSave,
  quoteDelete,
  ownQuoteSave,
  ownQuoteList,
  ownQuoteDelete,
  quoteList,
  merchantList,
  dictBrands,
  dictModels,
  dictCapacities
} from '@/api/priceMonitor'

export default {
  name: 'QuoteEntry',
  data() {
    return {
      merchants: [],
      brands: [],
      allModels: [],
      allCapacities: [],
      quoteModels: [],
      ownModels: [],
      quoteCapacities: [],
      ownCapacities: [],
      quoteForm: {
        merchant_id: '',
        brand: '',
        model_name: '',
        capacity: '',
        color: '',
        version: '',
        tenor_months: '',
        down_payment: '',
        total_price: '',
        buyout_price: '',
        monthly_payment: '',
        collected_at: '',
        source_url: ''
      },
      ownForm: {
        brand: '',
        model_name: '',
        capacity: '',
        color: '',
        version: '',
        tenor_months: '',
        down_payment: '',
        total_price: '',
        buyout_price: '',
        monthly_payment: '',
        effective_at: ''
      },
      query: { page: 1, pageSize: 20, model_name: '', tenor_months: '' },
      list: [],
      ownList: []
    }
  },
  created() {
    this.fetchMerchants()
    this.fetchBrands()
    this.fetchList()
    this.fetchOwnList()
  },
  methods: {
    async fetchMerchants() {
      const res = await merchantList({ page: 1, pageSize: 500, status: 'active' })
      if (res.code === 200) {
        this.merchants = res.data.list || []
      } else {
        this.merchants = []
      }
    },
    async fetchBrands() {
      const res = await dictBrands({})
      if (res.code === 200) {
        const list = res.data.list || []
        this.brands = list
      } else {
        this.brands = []
      }
      const modelRes = await dictModels({})
      this.allModels = modelRes.code === 200 ? (modelRes.data.list || []) : []
      const capacityRes = await dictCapacities({})
      this.allCapacities = capacityRes.code === 200 ? (capacityRes.data.list || []) : []
      this.quoteModels = [...this.allModels]
      this.ownModels = [...this.allModels]
      this.quoteCapacities = [...this.allCapacities]
      this.ownCapacities = [...this.allCapacities]
      await this.onQuoteBrandChange()
      await this.onOwnBrandChange()
    },
    async onQuoteBrandChange() {
      this.quoteForm.model_name = ''
      this.quoteForm.capacity = ''
      this.quoteModels = [...this.allModels]
      this.quoteCapacities = [...this.allCapacities]
      if (!this.quoteForm.brand) {
        return
      }
      const res = await dictModels({ brand: this.quoteForm.brand })
      if (res.code === 200) {
        const list = res.data.list || []
        this.quoteModels = list.length ? list : [...this.allModels]
      }
    },
    async onQuoteModelChange() {
      this.quoteForm.capacity = ''
      this.quoteCapacities = [...this.allCapacities]
      if (!this.quoteForm.brand || !this.quoteForm.model_name) {
        return
      }
      const res = await dictCapacities({
        brand: this.quoteForm.brand,
        model_name: this.quoteForm.model_name
      })
      if (res.code === 200) {
        const list = res.data.list || []
        this.quoteCapacities = list.length ? list : [...this.allCapacities]
      }
    },
    async onOwnBrandChange() {
      this.ownForm.model_name = ''
      this.ownForm.capacity = ''
      this.ownModels = [...this.allModels]
      this.ownCapacities = [...this.allCapacities]
      if (!this.ownForm.brand) {
        return
      }
      const res = await dictModels({ brand: this.ownForm.brand })
      if (res.code === 200) {
        const list = res.data.list || []
        this.ownModels = list.length ? list : [...this.allModels]
      }
    },
    async onOwnModelChange() {
      this.ownForm.capacity = ''
      this.ownCapacities = [...this.allCapacities]
      if (!this.ownForm.brand || !this.ownForm.model_name) {
        return
      }
      const res = await dictCapacities({
        brand: this.ownForm.brand,
        model_name: this.ownForm.model_name
      })
      if (res.code === 200) {
        const list = res.data.list || []
        this.ownCapacities = list.length ? list : [...this.allCapacities]
      }
    },
    async saveQuote() {
      if (
        !this.quoteForm.merchant_id ||
        !this.quoteForm.brand ||
        !this.quoteForm.model_name ||
        !this.quoteForm.tenor_months ||
        this.quoteForm.down_payment === '' ||
        !this.quoteForm.total_price ||
        this.quoteForm.buyout_price === ''
      ) {
        alert('请选择商家/品牌/型号，并填写期数/首付/总租金/买断价')
        return
      }
      if (Number(this.quoteForm.tenor_months) <= 1) {
        alert('期数必须大于1')
        return
      }
      if (Number(this.quoteForm.down_payment) > Number(this.quoteForm.total_price)) {
        alert('首付不能大于总租金')
        return
      }
      const res = await quoteSave(this.quoteForm)
      if (res.code === 200) {
        alert('保存成功')
        this.fetchBrands()
        this.fetchList()
      } else {
        alert(res.msg || '保存失败')
      }
    },
    async saveOwn() {
      if (
        !this.ownForm.brand ||
        !this.ownForm.model_name ||
        !this.ownForm.tenor_months ||
        this.ownForm.down_payment === '' ||
        !this.ownForm.total_price ||
        this.ownForm.buyout_price === ''
      ) {
        alert('请选择品牌/型号，并填写期数/首付/总租金/买断价')
        return
      }
      if (Number(this.ownForm.tenor_months) <= 1) {
        alert('期数必须大于1')
        return
      }
      if (Number(this.ownForm.down_payment) > Number(this.ownForm.total_price)) {
        alert('首付不能大于总租金')
        return
      }
      const res = await ownQuoteSave(this.ownForm)
      if (res.code === 200) {
        alert('保存成功')
        this.fetchBrands()
        this.fetchOwnList()
      } else {
        alert(res.msg || '保存失败')
      }
    },
    async fetchOwnList() {
      const res = await ownQuoteList({ page: 1, pageSize: 20 })
      if (res.code === 200) {
        this.ownList = res.data.list || []
      } else {
        this.ownList = []
      }
    },
    async removeOwnQuote(row) {
      if (!row || !row.id) {
        return
      }
      if (!window.confirm('确认删除该我方报价吗？')) {
        return
      }
      const res = await ownQuoteDelete({ id: row.id })
      if (res.code === 200) {
        alert('删除成功')
        this.fetchOwnList()
      } else {
        alert(res.msg || '删除失败')
      }
    },
    async removeQuote(row) {
      if (!row || !row.id) {
        return
      }
      if (!window.confirm('确认删除该报价吗？')) {
        return
      }
      const res = await quoteDelete({ id: row.id })
      if (res.code === 200) {
        alert('删除成功')
        this.fetchList()
      } else {
        alert(res.msg || '删除失败')
      }
    },
    async fetchList() {
      const res = await quoteList(this.query)
      if (res.code === 200) {
        this.list = res.data.list || []
      } else {
        alert(res.msg || '查询失败')
      }
    },
    recalcQuoteMonthly() {
      const tenor = Number(this.quoteForm.tenor_months || 0)
      const total = Number(this.quoteForm.total_price || 0)
      const down = Number(this.quoteForm.down_payment || 0)
      if (tenor > 1 && down <= total) {
        const value = (total - down) / (tenor - 1)
        this.quoteForm.monthly_payment = Number.isFinite(value) ? Number(value.toFixed(2)) : ''
      } else {
        this.quoteForm.monthly_payment = ''
      }
    },
    recalcOwnMonthly() {
      const tenor = Number(this.ownForm.tenor_months || 0)
      const total = Number(this.ownForm.total_price || 0)
      const down = Number(this.ownForm.down_payment || 0)
      if (tenor > 1 && down <= total) {
        const value = (total - down) / (tenor - 1)
        this.ownForm.monthly_payment = Number.isFinite(value) ? Number(value.toFixed(2)) : ''
      } else {
        this.ownForm.monthly_payment = ''
      }
    }
  }
}
</script>

<style scoped>
.card { background: #fff; border-radius: 8px; padding: 16px; }
.grid { display: grid; grid-template-columns: repeat(4, minmax(180px, 1fr)); gap: 10px; }
.actions { margin: 10px 0 0; }
.toolbar { display: flex; gap: 10px; margin: 12px 0; }
input, select, button { height: 34px; padding: 0 10px; border: 1px solid #d1d5db; border-radius: 6px; }
button { cursor: pointer; background: #fff; }
button.primary { background: #2563eb; color: #fff; border-color: #2563eb; }
table { margin-top: 8px; width: 100%; border-collapse: collapse; }
th, td { border: 1px solid #e5e7eb; padding: 8px; font-size: 13px; text-align: left; }
</style>
